import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { APP_ROUTES, API } from "../../globals/constants";
import "./header.scss";
import logo from "../../Images/png/logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import userImage from "../../Images/whiteImg.svg";
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from "react-redux";
import { USER_LOGOUT } from "../../redux/features/login";
import axios from "axios";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import api_call from "../../globals/common_utilities/axios_old";
import Phone from "../../Images/Dial3.svg";
import Email from "../../Images/Email3.svg";
import { Typography } from "@mui/material";

function Header() {
  const [clearIcon, setClearIcon] = useState(false);
  const [styleTraining, setStyleTraining] = useState(true);
  const [styleTrainingPartner, setStyleTrainingPartner] = useState(true);
  const [stylemore, setstylemore] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let activeStyle = {
    // textDecoration: 'underline',
    // color: 'red',
    fontWeight: "bolder",
    fontSize: "10px",
  };

  const moreChangeStyle = () => {
    setstylemore(!stylemore);
  };

  const TrainingPartnerStyleChange = () => {
    setStyleTrainingPartner(!styleTrainingPartner);
  };

  const changeStyle = () => {
    setStyleTraining(!styleTraining);
  };
  const menuBar = () => {
    var x = document.getElementById("myTopnav");
    if (x.className === "topnav") {
      x.className += " responsive";
      setClearIcon(!clearIcon);
    } else {
      x.className = "topnav";
      setClearIcon(!clearIcon);
    }
  };
  const sendEmail = () => {
    window.open(
      `mailto:support@mail-acc.com?subject= EPC001 Live Training - Epic Games Support`
    );
  };
  const cookies = new Cookies();

  const loginData = cookies.get("loginData");
  console.log("loginData", loginData);
  let userRole = loginData?.role_code;
  let userName = loginData?.name || "";
  let trimUserName = userName.substring(0, 15);

  const logout = async () => {
    // cookies.set('loginData', 'undefined', { path: '/' });

    const response = await api_call(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.LOGOUT,
      {}
    );
    if (response.status === 200) {
      navigate(APP_ROUTES.ROUTE_LOGIN);
      dispatch(USER_LOGOUT());
      cookies.remove("loginData", { path: "/" });
    } else {
    }
  };

  const dashBoardRedirct = () => {
    navigate(APP_ROUTES.ROUTE_ROOT);
  };

  const setHeader = (setUserRole) => {
    switch (setUserRole || "") {
      case "SUPER_ADMIN":
        return (
          <div className="Items">
            <img
              src={logo}
              alt="logo"
              className="logoStyleSet"
              onClick={() => {
                dashBoardRedirct();
              }}
            />
            <NavLink
              className="navItems fs-7"
              to={APP_ROUTES.ROUTE_ROOT}
              onClick={() => {
                menuBar();
              }}
            >
              Dashboard
            </NavLink>
            <NavLink className="fsText navItems">
              <div class="dropdown">
                <span className="fs-7">
                  Training
                  <ArrowDropDownIcon sx={{ marginBottom: "-8px" }} />
                </span>
                <div className="dropdown-content">
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.VEYON}
                  >
                    Training
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_IMAGECONFIGURATOR}
                  >
                    Image Configurator
                  </NavLink>
                </div>
              </div>
            </NavLink>
            <NavLink className="fsText pdSet navItems">
              <div class="dropdown">
                <span className="fs-7">
                  Training Partner
                  <ArrowDropDownIcon sx={{ marginBottom: "-8px" }} />
                </span>
                <div className="dropdown-content">
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_TRAININGCENTER}
                  >
                    Training Center
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_TRAININGCENTER_ADMIN}
                  >
                    TC Admin
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_INSTRUCTOR}
                  >
                    Instructor
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_STUDENT}
                  >
                    Student
                  </NavLink>
                </div>
              </div>
            </NavLink>
            <NavLink
              className="navItems fs-7"
              to={APP_ROUTES.ROUTE_CREATESESSION}
              onClick={() => {
                menuBar();
              }}
            >
              Create Session
            </NavLink>
            <NavLink className="fsText pdSet navItems">
              <div class="dropdown">
                <span className="fs-7">
                  More
                  <ArrowDropDownIcon sx={{ marginBottom: "-8px" }} />
                </span>
                <div className="dropdown-content mldropdown">
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.FEEDBACK_LISTING}
                  >
                    Student Feedback
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.FEEDBACK_TEMPLATE_LISTING}
                  >
                    Feedback Template
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.REPORTS}
                  >
                    Reports
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_EMAILTEMPLATELIST}
                  >
                    Email Template
                  </NavLink>
                </div>
              </div>
            </NavLink>
            {/* <NavLink className="fsText pdSet navItems"> */}
            <NavLink
              className="navItems fs-7"
              onClick={() => {
                menuBar();
              }}
              to={APP_ROUTES.CONTACTSUPPORT}
            >
              Contact Support
            </NavLink>
            {/* </NavLink> */}
            {clearIcon ? (
              <div className="hideProfile">
                <div class="dropdown marginSet">
                  <span
                    className="fs-7"
                    //  onClick={() => moreChangeStyle()}
                  >
                    {trimUserName}
                  </span>
                  <div className="dropdown-content">
                    <NavLink
                      className="fs-8"
                      onClick={() => {
                        menuBar();
                        logout();
                      }}
                      // to={APP_ROUTES.FEEDBACK_LISTING}
                    >
                      Logout
                    </NavLink>
                  </div>
                </div>

                <img
                  src={userImage}
                  alt="ProfileIcon"
                  className="profileImgDetails"
                />
              </div>
            ) : (
              ""
            )}
          </div>
        );
      case "STUDIO_ADMIN":
        return (
          <div className="Items">
            <img
              src={logo}
              alt="logo"
              className="logoStyleSet"
              onClick={() => {
                dashBoardRedirct();
              }}
            />
            <NavLink
              className="navItems fs-7"
              to={APP_ROUTES.ROUTE_ROOT}
              onClick={() => {
                menuBar();
              }}
            >
              Dashboard
            </NavLink>

            <NavLink className="fsText navItems">
              <div class="dropdown">
                <span className="fs-7">
                  Training
                  <ArrowDropDownIcon sx={{ marginBottom: "-8px" }} />
                </span>
                <div className="dropdown-content">
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.VEYON}
                  >
                    Training
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_IMAGECONFIGURATOR}
                  >
                    Image Configurator
                  </NavLink>
                </div>
              </div>
            </NavLink>
            {/* <NavLink
							className="navItems fs-7"
							to={APP_ROUTES.ROUTE_INSTRUCTOR}
							onClick={() => {
								menuBar();
							}}
						>
							Instructor
						</NavLink> */}
            <NavLink className="fsText pdSet navItems">
              <div class="dropdown">
                <span className="fs-7">
                  Training Partner
                  <ArrowDropDownIcon sx={{ marginBottom: "-8px" }} />
                </span>
                <div className="dropdown-content">
                  {/* <NavLink
										className="fs-8"
										onClick={() => {
											menuBar();
										}}
										to={APP_ROUTES.ROUTE_TRAININGCENTER}
									>
										Training Center
									</NavLink> */}
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_TRAININGCENTER_ADMIN}
                  >
                    TC Admin
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_INSTRUCTOR}
                  >
                    Instructor
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_STUDENT}
                  >
                    Student
                  </NavLink>
                </div>
              </div>
            </NavLink>
            {/* <NavLink
							className="navItems fs-7"
							to={APP_ROUTES.ROUTE_STUDENT}
							onClick={() => {
								menuBar();
							}}
						>
							Student
						</NavLink> */}
            <NavLink
              className="navItems fs-7"
              to={APP_ROUTES.ROUTE_CREATESESSION}
              onClick={() => {
                menuBar();
              }}
            >
              Create Session
            </NavLink>
            <NavLink className="fsText pdSet navItems">
              <div class="dropdown">
                <span className="fs-7">
                  More
                  <ArrowDropDownIcon sx={{ marginBottom: "-8px" }} />
                </span>
                <div className="dropdown-content mldropdown">
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.FEEDBACK_LISTING}
                  >
                    Student Feedback
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.FEEDBACK_TEMPLATE_LISTING}
                  >
                    Feedback Template
                  </NavLink>
                  {/* <NavLink
										className="fs-8"
										onClick={() => {
											menuBar();
										}}
										to={APP_ROUTES.REPORTS}
									>
										Reports
									</NavLink> */}
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.ROUTE_EMAILTEMPLATELIST}
                  >
                    Email Template
                  </NavLink>
                </div>
              </div>
            </NavLink>
            {/* <NavLink className="fsText pdSet navItems"> */}
            <NavLink
              className="navItems fs-7"
              onClick={() => {
                menuBar();
              }}
              to={APP_ROUTES.CONTACTSUPPORT}
            >
              Contact Support
            </NavLink>
            {/* </NavLink> */}

            {clearIcon ? (
              <div className="hideProfile">
                <div class="dropdown marginSet">
                  <span
                    className="fs-7"
                    //  onClick={() => moreChangeStyle()}
                  >
                    {trimUserName}
                  </span>
                  <div className="dropdown-content">
                    <NavLink
                      className="fs-8"
                      onClick={() => {
                        menuBar();
                        logout();
                      }}
                      // to={APP_ROUTES.FEEDBACK_LISTING}
                    >
                      Logout
                    </NavLink>
                  </div>
                </div>

                <img
                  src={userImage}
                  alt="ProfileIcon"
                  className="profileImgDetails"
                />
              </div>
            ) : (
              ""
            )}
          </div>
        );
      case "STUDENT":
        return (
          <div className="Items">
            <img
              src={logo}
              alt="logo"
              className="logoStyleSet"
              onClick={() => {
                dashBoardRedirct();
              }}
            />
            <NavLink
              className="navItems fs-7"
              to={APP_ROUTES.VEYON}
              onClick={() => {
                menuBar();
              }}
            >
              Home
            </NavLink>
            <NavLink
              className="navItems fs-7"
              to={APP_ROUTES.TRAINING_LISTING}
              onClick={() => {
                menuBar();
              }}
            >
              Trainings
            </NavLink>
            {clearIcon ? (
              <div className="hideProfile">
                <div class="dropdown">
                  <span
                    className="fs-7"
                    //  onClick={() => moreChangeStyle()}
                  >
                    {trimUserName}
                  </span>
                  <div className="dropdown-content">
                    <NavLink
                      className="fs-8"
                      onClick={() => {
                        menuBar();
                        logout();
                      }}
                      // to={APP_ROUTES.FEEDBACK_LISTING}
                    >
                      Logout
                    </NavLink>
                  </div>
                </div>

                <img
                  src={userImage}
                  alt="ProfileIcon"
                  className="profileImgDetails"
                />
              </div>
            ) : (
              ""
            )}
          </div>
        );
      case "INSTRUCTOR":
        return (
          <div className="Items">
            <img
              src={logo}
              alt="logo"
              className="logoStyleSet"
              onClick={() => {
                dashBoardRedirct();
              }}
            />
            <NavLink
              className="navItems fs-7"
              to={APP_ROUTES.VEYON}
              onClick={() => {
                menuBar();
              }}
            >
              Home
            </NavLink>
            <NavLink
              className="navItems fs-7"
              to={APP_ROUTES.TRAINING_LISTING}
              onClick={() => {
                menuBar();
              }}
            >
              Trainings
            </NavLink>
            <NavLink
              className="navItems fs-7"
              to={APP_ROUTES.ROUTE_CREATESESSION}
              onClick={() => {
                menuBar();
              }}
            >
              Create Session
            </NavLink>
            <NavLink className="fsText pdSet navItems">
              <div class="dropdown">
                <span className="fs-7">
                  More
                  <ArrowDropDownIcon sx={{ marginBottom: "-8px" }} />
                </span>
                <div className="dropdown-content mldropdown">
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.FEEDBACK_LISTING}
                  >
                    Student Feedback
                  </NavLink>
                  <NavLink
                    className="fs-8"
                    onClick={() => {
                      menuBar();
                    }}
                    to={APP_ROUTES.FEEDBACK_TEMPLATE_LISTING}
                  >
                    Feedback Template
                  </NavLink>
                </div>
              </div>
            </NavLink>
            {/* <NavLink className="fsText pdSet navItems"> */}
            <NavLink
              className="navItems fs-7"
              onClick={() => {
                menuBar();
              }}
              to={APP_ROUTES.CONTACTSUPPORT}
            >
              Contact Support
            </NavLink>
            {/* </NavLink> */}

            {clearIcon ? (
              <div className="hideProfile">
                <div class="dropdown">
                  <span
                    className="fs-7"
                    //  onClick={() => moreChangeStyle()}
                  >
                    {trimUserName}
                  </span>
                  <div className="dropdown-content">
                    <NavLink
                      className="fs-8"
                      onClick={() => {
                        menuBar();
                        logout();
                      }}
                      // to={APP_ROUTES.FEEDBACK_LISTING}
                    >
                      Logout
                    </NavLink>
                  </div>
                </div>

                <img
                  src={userImage}
                  alt="ProfileIcon"
                  className="profileImgDetails"
                />
              </div>
            ) : (
              ""
            )}
          </div>
        );
      default:
        break;
    }
  };

  return (
    <>
      <div class="topnav" id="myTopnav">
        {setHeader(userRole)}
        <div className="profileDetails ">
          <div class="dropdown">
            <span className="fs-7">{trimUserName}</span>
            <div className="dropdown-content">
              <NavLink
                className="fs-8"
                onClick={() => {
                  menuBar();
                  logout();
                }}
              >
                Logout
              </NavLink>
            </div>
          </div>
          <img
            src={userImage}
            alt="ProfileIcon"
            className="profileImgDetails"
          />
        </div>
        <div className="responsive">
          <div className="icon" onClick={menuBar}>
            {clearIcon ? <ClearIcon /> : <MenuIcon />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
